import { getCurrentSession } from '../../lib/authentication';

export const getUnderWriter = id => {
    return getCurrentSession().then(result => {
        const { idToken } = result;
        return apigClient.adminUsersIdGet(
            { id },
            {},
            {
                headers: {
                    Authorization: idToken
                }
            }
        );
    });
};

export const getBroker = id => {
    return getCurrentSession().then(result => {
        const { idToken } = result;
        return apigClient.apiGetBrokerIdGet(
            { id },
            {},
            {
                headers: {
                    Authorization: idToken
                }
            }
        );
    });
};
